import { FilterDTO, FilterOperator, SortDirection } from './../../models/models.swagger.generated';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth.service';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ClientClient, ClientDTO, PagedResultDTOOfClientDTO } from 'src/app/base/models/models.swagger.generated';
import { catchError, tap } from 'rxjs/operators';
import { ToastService } from 'src/app/base/services/toast.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ErrorType } from 'src/app/core/routing/error-types';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(
    private authService: AuthService,
    private clientAdministrationClient: ClientClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService
  ) { }

  public clients: ClientDTO[];
  public numberOfClients: number;
  public selectedClient: ClientDTO;

  public getAccessibleClients(): Observable<PagedResultDTOOfClientDTO> {
    const loggedInUser = this.authService.getUserInfo();
    if (loggedInUser.client) {
      this.selectedClient = loggedInUser.client;
      this.clients = [loggedInUser.client];
      return of({
        items: [loggedInUser.client],
        totalNumberOfItems: 1
      } as PagedResultDTOOfClientDTO);
    } else {
      this.spinnerService.showSpinner = true;

      const activeFilter = new FilterDTO({isComplex: false, field: 'IsActive', operator: FilterOperator.Equal, value: 'true'});
      return this.clientAdministrationClient.searchClients([activeFilter], 0, 0, 'name', SortDirection.Ascending)
        .pipe(
          tap((pagedResult: PagedResultDTOOfClientDTO) => {
            this.spinnerService.showSpinner = false;
            this.clients = pagedResult.items;
            this.numberOfClients = pagedResult.totalNumberOfItems;
            if (this.numberOfClients === 1) {
              this.selectedClient = this.clients[0];
            }
          }),
          catchError((error: any) => {
            this.spinnerService.showSpinner = false;
            if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
              this.toastService.showError('i18n.errors.server-error.title',
              'i18n.errors.server-error.message', null, ErrorType.serverError);
            }
            return of(error);
          })
        );
    }
  }
}
